import React from "react";

function SortedBy({ filter, setFilter, type, togglePopup }) {
  const PreReadbtns = document.querySelectorAll(".AssDess");
  PreReadbtns.forEach((btnElCM) => {
    btnElCM.addEventListener("click", () => {
      document
        .querySelector(".sortByFocused")
        ?.classList.remove("sortByFocused");
      btnElCM.classList.add("sortByFocused");
    });
  });

  let conditionalStyles;
  switch (type) {
    case "Homework":
      conditionalStyles = { position: "absolute", top: "280px", right: "60px" };
      break;
    case "Self-Assessment":
      conditionalStyles = { position: "absolute", top: "210px", right: "60px" };
      break;
    case "Pre-read":
      conditionalStyles = { position: "absolute", top: "280px", right: "60px" };
      break;
    case "Activity":
      conditionalStyles = { position: "absolute", top: "360px", right: "70px" };
      break;
    default:
      conditionalStyles = { position: "absolute", top: "24px", right: "188px" };
      break;
  }
  return (
    <div className="sortByContainer p-3"
      style={{ ...conditionalStyles }}
    >
      <div className="sortbyDate">DATE</div>
      <button
        onClick={() => { setFilter({ ...filter, sortBy: 1 }); }}
        className={`${filter.sortBy === 1 && "sortByFocused"} AssDess mt-2`}
      >
        Ascending
      </button>
      <button
        onClick={() => { setFilter({ ...filter, sortBy: -1 }); }}
        className={`${filter.sortBy === -1 && "sortByFocused"} AssDess mt-2`}
      >
        Descending
      </button>
    </div>
  );
}

export default SortedBy;
